module.exports = __webpack_public_path__ + "static/media/user-astronaut.6a68f422.svg";